export const advanced = state => state.advanced
export const advancedFilter = state => state.advancedFilter
export const normalFilter = state => state.normalFilter
export const sortObj = state => state.sortObj
export const moduleName = state => state.moduleName
export const freshList = state => state.freshList
export const selectProducts = state => state.selectProducts
export const getSelectPu = state => state.selectPu // 选中的待采购
export const getSelectRows = state => state.selectRows
export const getSelectIds = state => state.selectIds
export const getAttr = state => state.attr
export const getRemindCount = state => state.remindCount
export const getErrorCode = state => state.errorCode
export const getDetailConfig = state => state.detailConfig
export const getListLoading = state => state.listLoading
export const getSidemenuStatus = state => state.sidemenuStatus
export const getUpdateAddress = state => state.updateAddress
export const getSpecialEnmus = state => state.specialEnmus
export const getAddNumIndex = state => state.addNumIndex // 扫码所在行序号
export const getPerformanceNavList = state => state.performanceNavList // 获取业绩目标指标列表
export const getPage = state => state.vuexPageObj // 进销存列表页面更新
export const getAliasList = state => state.aliasList // 菜单自定义
export const freshAllList = state => state.freshAllList // 刷新列表页上的所有接口




// WEBPACK FOOTER //
// ./src/store/getters.js